<template>
  <PerkContainer icon="financing-dark-medium" is-raw-clickable @value-info-click="openOverlay">
    <CcfpView :price="selectedPrice" :is-modal-open="isModalOpen" :is-product-perks-enabled="true" @close-ccfp-modal="onModalClose" />
  </PerkContainer>
</template>
<script setup>
import { ref } from 'vue';
import CcfpView from '@nuxt-common/media-card-large/app/modules/credit-finance/components/CcfpView';
import PerkContainer from '~/modules/productPerks/components/PerkContainer';
import { useProductPrice } from '~/modules/price/composables/useProductPrice';
import once from '~/utils/once';
import { ccfpDetailsClicked } from '~/features/analytics/productPerks';

const selectedPrice = useProductPrice();

const fireAnalytics = once(ccfpDetailsClicked);
const isModalOpen = ref(false);
const openOverlay = () => {
  fireAnalytics();
  isModalOpen.value = true;
};
const onModalClose = () => {
  isModalOpen.value = false;
};
</script>

<style lang="scss" scoped>
:deep(.ccfp-offer-wrapper) {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
}
</style>
